import { render, staticRenderFns } from "./TransferRequestInfo.vue?vue&type=template&id=c1a55a4a&scoped=true"
import script from "./TransferRequestInfo.vue?vue&type=script&lang=js"
export * from "./TransferRequestInfo.vue?vue&type=script&lang=js"
import style0 from "./TransferRequestInfo.vue?vue&type=style&index=0&id=c1a55a4a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1a55a4a",
  null
  
)

export default component.exports